const siteKey = import.meta.env.VUE_APP_RECAPTCHA_KEY;

if (siteKey) {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  script.async = true;
  document.head.appendChild(script);
}
